let host = window.location.host.indexOf('localhost') > -1 ? 'local' : window.location.host.replace('admin.icru.co.kr', '').replace('icru.co.kr', '')
if (!host)
  host = 'prod'

const config={
    local: {
  	  CLIENT_ID: 'kr.co.icru',
      API_URL: "http://localhost:31011",
      COOKIE_URL: 'localhost',
    },
    prod: {
      CLIENT_ID: 'kr.co.icru',
      API_URL: "https://api.icru.co.kr",
      COOKIE_URL: '.icru.co.kr',
    }
}

export default config[host];